import {
  checkBackgroundIsDark,
  newColorShadeInHex6,
  getReadableTextColor,
} from "../../../redux/constants";

// componentMapping.js
export const componentMapping = {
  CommandCenterScreenBanner: {
    cssVariable: "--locobuzz-cc-screen-banner-bg-color",
    stateKey: "CommandCenterScreenBanner",
  },
  CommandCenterScreenBannerTextColor: {
    cssVariable: "--locobuzz-cc-screen-banner-text-color",
    stateKey: "CommandCenterScreenBanner",
  },
  CommandCenterScreenFooterTextColor: {
    cssVariable: "--locobuzz-cc-screen-footer-text-color",
    stateKey: "CommandCenterScreenFooter",
  },
  CommandCenterScreenWidgetHeaderColor: {
    cssVariable: "--locobuzz-cc-widget-header-bg-color",
    stateKey: "WidgetHeaderColor",
  },
  CommandCenterScreenWidgetBackgroundColor: {
    cssVariable: "--locobuzz-cc-widget-content-bg-color",
    stateKey: "WidgetBackgroundColor",
  },
  CommandCenterScreenWidgetHeaderTextColor: {
    cssVariable: "--locobuzz-primary-text-color",
    stateKey: "PrimaryTextColor",
    dependentCssVariables: [
      "--locobuzz-primary-text-color",
      "--nonactionable-icon-color",
    ],
  },
  CommandCenterWidgetChartTextColor: {
    cssVariable: "--locobuzz-secondary-text-color",
    stateKey: "SecondaryTextColor",
  },
  CommandCenterScreenBackgroundColor: {
    cssVariable: "--locobuzz-cc-screen-container-bg-primary-color",
    stateKey: "ScreenBackgroundColor",
    dependentCssVariables: [
      "--locobuzz-secondary-bg-color",
      "--locobuzz-border-color",
      "--locobuzz-border-secondary-color",
      "--brand-post-comment-header-text",
      "--locobuzz-primary-bg-color",
      "--locobuzz-btn-active-bg-color",
    ],
  },
  CommandCenterScreenBackgroundSecondaryColor: {
    cssVariable: "--locobuzz-cc-screen-container-bg-secondary-color",
    stateKey: "ScreenBackgroundSecondaryColor",
    dependentCssVariables: ["--locobuzz-secondary-bg-lighter-color"],
  },

  CommandCenterSelectedAccentColor: {
    cssVariable: "--cc-accent-color",
    stateKey: "AccentColors",
  },
};
export const updateVariableValueBasedOnThemeOrRoot = (
  cssVariableName,
  cssVariableValue,
  theme = null
) => {
  if (!cssVariableName || !cssVariableValue) return;
  // currently i'm assigning by default theme=customTheme
  theme = "customTheme";
  // console.log(
  //   "updateVariableValueBasedOnThemeOrRoot : ",
  //   cssVariableName,
  //   cssVariableValue
  // );
  const themeElement = theme
    ? document?.querySelector(`[data-theme="${theme}"]`)
    : null;
  // currently stop this approch
  if (cssVariableName?.toLowerCase() === "--locobuzz-base-fontsize" && false) {
    if (themeElement) {
      themeElement.style.fontSize = `${cssVariableValue}%`;
      // for testing purpose updating both root level value also //check here
      document.documentElement.style.fontSize = `${cssVariableValue}%`;
    } else {
      document.documentElement.style.fontSize = `${cssVariableValue}%`;
    }
  } else {
    if (themeElement) {
      themeElement?.style?.setProperty(cssVariableName, cssVariableValue);
      // for testing purpose updating both root level value also //check here
      document?.documentElement?.style?.setProperty(
        cssVariableName,
        cssVariableValue
      );
    } else {
      document?.documentElement?.style?.setProperty(
        cssVariableName,
        cssVariableValue
      );
    }
  }
};

export const applyThemeWithVariable = (theme) => {
  // Mapping css variables used to the corresponding keys in response theme

  // Find the selected palette from the paletteList
  let selectedPalette = theme?.theme_json?.paletteList?.find(
    (palette) => palette?.isSelected
  );
  if (!selectedPalette) {
    selectedPalette = theme?.theme_json?.paletteList?.[0];
  }
  const isDarkScreenBackground = checkBackgroundIsDark(
    selectedPalette?.ScreenBackgroundColor
  );
  // DYNAMIC HIGHLIGHTED COLOR
  const secondaryBackgroundColor = newColorShadeInHex6(
    selectedPalette?.ScreenBackgroundColor,
    45,
    isDarkScreenBackground
  );
  const newHighlight = getReadableTextColor(secondaryBackgroundColor);

  const cssVariableMapping = {
    // CommandCenterScreenBanner
    "--locobuzz-cc-screen-banner-bg-color":
      theme?.theme_json?.CommandCenterScreenBanner?.background,
    "--locobuzz-cc-screen-banner-text-color":
      theme?.theme_json?.CommandCenterScreenBanner?.textColor || "#ffffff",
    "--locobuzz-cc-screen-banner-font-weight":
      theme?.theme_json?.CommandCenterScreenBanner?.fontWeight,
    "--locobuzz-cc-screen-banner-font-size":
      theme?.theme_json?.CommandCenterScreenBanner?.fontSize,
    "--locobuzz-cc-screen-banner-font-family":
      theme?.theme_json?.CommandCenterScreenBanner?.fontFamily,

    // CommandCenterScreenFooter
    "--locobuzz-cc-screen-footer-text-color":
      theme?.theme_json?.CommandCenterScreenFooter?.textColor || "#ffffff",

    //paletteList
    "--locobuzz-cc-screen-container-bg-primary-color":
      selectedPalette?.ScreenBackgroundColor,

    //dependentCssVariables on ScreenBackgroundColor Starts here
    "--locobuzz-primary-bg-color": selectedPalette?.ScreenBackgroundColor,

    "--locobuzz-secondary-bg-lighter-color": newColorShadeInHex6(
      selectedPalette?.ScreenBackgroundColor,
      54,
      isDarkScreenBackground
    ),
    "--locobuzz-secondary-bg-color": newColorShadeInHex6(
      selectedPalette?.ScreenBackgroundColor,
      45,
      isDarkScreenBackground
    ),
    "--color-keyword-highlight-1": newHighlight,
    "--color-keywors-highlight-2": newHighlight,
    "--color-keyword-highlight-text-color": secondaryBackgroundColor,
    "--locobuzz-border-color": newColorShadeInHex6(
      selectedPalette?.ScreenBackgroundColor,
      45,
      isDarkScreenBackground
    ),
    "--locobuzz-border-secondary-color": newColorShadeInHex6(
      selectedPalette?.ScreenBackgroundColor,
      54,
      isDarkScreenBackground
    ),
    "--locobuzz-cc-screen-container-bg-secondary-color": newColorShadeInHex6(
      selectedPalette?.ScreenBackgroundColor,
      25,
      isDarkScreenBackground
    ),
    "--brand-post-comment-header-text": isDarkScreenBackground
      ? "#e2e2e2"
      : "#3b5175",

    //dependentCssVariables on ScreenBackgroundColor End here

    "--locobuzz-cc-widget-header-bg-color": selectedPalette?.WidgetHeaderColor,
    "--locobuzz-primary-text-color": selectedPalette?.PrimaryTextColor,
    "--nonactionable-icon-color": selectedPalette?.PrimaryTextColor,
    "--locobuzz-primary-text-color": selectedPalette?.PrimaryTextColor,

    "--locobuzz-secondary-text-color": selectedPalette?.SecondaryTextColor,
    "--locobuzz-secondary-text-color": selectedPalette?.SecondaryTextColor,

    "--locobuzz-cc-widget-content-bg-color":
      selectedPalette?.WidgetBackgroundColor,
    "--locobuzz-btn-active-bg-color": isDarkScreenBackground
      ? selectedPalette?.WidgetBackgroundColor
      : newColorShadeInHex6(
          selectedPalette?.WidgetBackgroundColor,
          20,
          isDarkScreenBackground
        ),
  };
  // Apply each CSS variable
  for (const [cssVar, value] of Object.entries(cssVariableMapping)) {
    if (value !== null && value !== undefined) {
      updateVariableValueBasedOnThemeOrRoot(cssVar, value);
    }
  }

  // Apply CSS variables for the selected palette
  // if (selectedPalette) {
  // const isDarkScreenBackground = checkBackgroundIsDark(
  //   selectedPalette?.ScreenBackgroundColor
  // );
  // const secondaryBackgroundColor = newColorShadeInHex6(
  //   selectedPalette?.ScreenBackgroundColor,
  //   45,
  //   isDarkScreenBackground
  // );
  // const newHighlight = getReadableTextColor(secondaryBackgroundColor);
  const paletteMapping = {
    "--locobuzz-cc-screen-container-bg-primary-color":
      selectedPalette?.ScreenBackgroundColor,

    //dependentCssVariables on ScreenBackgroundColor Starts here
    "--locobuzz-primary-bg-color": selectedPalette?.ScreenBackgroundColor,
    "--locobuzz-secondary-bg-lighter-color": newColorShadeInHex6(
      selectedPalette?.ScreenBackgroundColor,
      54,
      isDarkScreenBackground
    ),
    "--locobuzz-secondary-bg-color": newColorShadeInHex6(
      selectedPalette?.ScreenBackgroundColor,
      45,
      isDarkScreenBackground
    ),
    "--color-keyword-highlight-1": newHighlight,
    "--color-keyword-highlight-2": newHighlight,
    "--color-keyword-highlight-text-color": newColorShadeInHex6(
      selectedPalette?.ScreenBackgroundColor,
      45,
      isDarkScreenBackground
    ),
    "--locobuzz-border-color": newColorShadeInHex6(
      selectedPalette?.ScreenBackgroundColor,
      45,
      isDarkScreenBackground
    ),
    "--locobuzz-border-secondary-color": newColorShadeInHex6(
      selectedPalette?.ScreenBackgroundColor,
      54,
      isDarkScreenBackground
    ),
    "--locobuzz-cc-screen-container-bg-secondary-color": newColorShadeInHex6(
      selectedPalette?.ScreenBackgroundColor,
      25,
      isDarkScreenBackground
    ),
    "--brand-post-comment-header-text": isDarkScreenBackground
      ? "#e2e2e2"
      : "#3b5175",

    //dependentCssVariables on ScreenBackgroundColor End here

    "--locobuzz-cc-widget-header-bg-color": selectedPalette?.WidgetHeaderColor,
    "--locobuzz-primary-text-color": selectedPalette?.PrimaryTextColor,
    "--nonactionable-icon-color": selectedPalette?.PrimaryTextColor,

    "--locobuzz-secondary-text-color": selectedPalette?.SecondaryTextColor,

    "--locobuzz-cc-widget-content-bg-color":
      selectedPalette?.WidgetBackgroundColor,
    "--locobuzz-btn-active-bg-color": isDarkScreenBackground
      ? selectedPalette?.WidgetBackgroundColor
      : newColorShadeInHex6(
          selectedPalette?.WidgetBackgroundColor,
          20,
          isDarkScreenBackground
        ),
    "--cc-first-selected-accent-color": selectedPalette?.AccentColors?.[0],
    "--cc-second-selected-accent-color": selectedPalette?.AccentColors?.[1],
    // "--widgetHeader--text--color": selectedPalette.WidgetHeaderColor,
  };

  for (const [cssVar, value] of Object.entries(paletteMapping)) {
    if (value !== null && value !== undefined) {
      updateVariableValueBasedOnThemeOrRoot(cssVar, value);
    }
  }
  // }
};
